// KontaktPage: Public contact form — accessible without login.
// Serves as the second contact method required by § 5 DDG.
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Send, CheckCircle } from 'lucide-react';
import { apiClient } from '../api/apiClient';
import { errorMessage } from '../api/errorMessage';
import './LegalPage.css';

export default function KontaktPage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await apiClient.post('/api/contact', { name: name.trim(), email: email.trim(), message: message.trim() });

      setSuccess(true);
    } catch (err) {
      setError(errorMessage(err, 'Nachricht konnte nicht gesendet werden.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="legal-page">
      <div className="legal-page__content">
        <button
          className="legal-page__back"
          onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <ArrowLeft size={16} /> Zurück
        </button>

        <h1>Kontakt</h1>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
          Du hast eine Frage, einen Fehler gefunden oder möchtest deine Rechte gemäß DSGVO ausüben?
          Nutze das folgende Formular, um uns zu kontaktieren.
        </p>

        {success ? (
          <div style={{
            textAlign: 'center',
            padding: '40px 20px',
          }}>
            <CheckCircle
              size={48}
              style={{ color: 'var(--success)', marginBottom: '16px' }}
            />
            <h2 style={{ color: 'var(--text-primary)', marginBottom: '8px' }}>
              Nachricht gesendet
            </h2>
            <p style={{ color: 'var(--text-secondary)' }}>
              Vielen Dank für deine Nachricht. Wir melden uns so schnell wie möglich bei dir.
            </p>
            <div style={{ marginTop: '24px', display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <Link to="/impressum" style={{ color: 'var(--accent)', fontSize: 'var(--text-sm)' }}>
                Impressum
              </Link>
              <Link to="/datenschutz" style={{ color: 'var(--accent)', fontSize: 'var(--text-sm)' }}>
                Datenschutz
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="kontakt-form">
            {error && (
              <div style={{
                background: 'var(--status-error-bg)',
                color: 'var(--status-error-fg)',
                padding: '12px 15px',
                borderRadius: 'var(--radius-md)',
                borderLeft: '4px solid var(--status-error-border)',
                marginBottom: '16px',
                fontSize: 'var(--text-sm)',
              }}>
                {error}
              </div>
            )}

            <div className="kontakt-form__group">
              <label htmlFor="contact-name">Name</label>
              <input
                id="contact-name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Dein Name"
                required
                minLength={2}
              />
            </div>

            <div className="kontakt-form__group">
              <label htmlFor="contact-email">E-Mail</label>
              <input
                id="contact-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="deine@email.de"
                required
              />
            </div>

            <div className="kontakt-form__group">
              <label htmlFor="contact-message">Nachricht</label>
              <textarea
                id="contact-message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Deine Nachricht..."
                required
                minLength={10}
                maxLength={5000}
                rows={6}
              />
              <span className="kontakt-form__charcount">
                {message.length} / 5000
              </span>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                marginTop: '8px',
              }}
            >
              <Send size={16} />
              {loading ? 'Wird gesendet...' : 'Nachricht senden'}
            </button>
          </form>
        )}

        <p style={{ marginTop: '24px', fontSize: 'var(--text-xs)', color: 'var(--text-muted)' }}>
          Deine Angaben werden ausschließlich zur Bearbeitung deiner Anfrage verwendet.
          Weitere Informationen findest du in unserer{' '}
          <Link to="/datenschutz">Datenschutzerklärung</Link>.
        </p>
      </div>
    </div>
  );
}
